<template>
  <div v-show="products?.length || loading" class="pb-3 lg:pb-6">
    <div v-if="title" class="mx-4 flex items-center pb-2 pt-6 between lg:mx-6 lg:pb-4">
      <h2 v-style:c="titleColor" :class="titleStyle">
        <span v-if="$feature.showTitleHtml" v-html="titleHtml" />
        <span v-else>{{ title }}</span>
      </h2>
      <vf-carousel-controls :carousel-ref :variant="backgroundType" />
    </div>
    <vf-carousel-elevate
      ref="carouselRef"
      class-container="gap-0 lg:-mr-1"
      class-controls="h-10 w-10 bg-brand-1 bg-op-50 p-2 c-white shadow-sm @hactive:bg-brand-1 @hactive:bg-op-90"
      :show-arrows="$viewport.md && !title"
      :show-arrows-on-hover-only="$viewport.md && !title"
      size-controls="md"
      :slides-to-scroll="!$viewport.md ? 'auto' : (variant === '6-cards' ? 6 : 3)"
    >
      <template v-if="!products?.length">
        <div
          v-for="i in 6"
          :key="i"
          v-style:w="variantStyleMap[variant]"
          class="pr-1 children:skeleton"
        >
          <div style="aspect-ratio: 0.72" />
        </div>
      </template>
      <template v-else>
        <div
          v-for="(product, i) in products"
          :key="product.id"
          v-style:w="variantStyleMap[variant]"
          class="pr-1"
        >
          <product-card-recommended
            :currency
            v-bind="product"
            :gtm-config="{ placement, title }"
            :quickshop
            :variant
            @product-click="$emit('product-click', product, i + 1)"
          />
        </div>
      </template>
    </vf-carousel-elevate>
  </div>
</template>

<script lang="ts" setup>
import type { Props } from '#types/components/cms/recommendation-carousel'
import { getPageInfo } from '#commerce/gtm/page'

const {
  backgroundType,
  currency,
  products,
  quickshop = true,
  title,
  titleStyle = 'body-2',
  variant = '6-cards'
} = defineProps<Props>()

defineEmits<{
  'product-click': [product: any, position: number]
}>()

const { variantStyleMap } = useAppConfig().components.cms.bloomreachRecommendations

const route = useRoute()
const carouselRef = ref()
const [placement] = variant === 'search-hub' ? [extractPageType('/searchhub')] : getPageInfo(route, {})
</script>
